var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.emptyData)?_c('shortcuts-panel',{attrs:{"shortcut-class-suffix":"goals","shortcuts-data":_vm.goalsShortcutData},on:{"clickedLink":_vm.sendGoalShortcutEvent},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h3',[_vm._v("Goals, objectives, and progress monitoring assessments")])]},proxy:true}],null,false,942510971)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }